import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceAvailabilityRoutingModule } from './service-availability-routing.module';
import { TDUDetailsComponent } from './tdu-details/tdu-details.component';
import { ServiceAvailabilityService }          from './service-availability.service';
import { PipeModule }    from '../shared/pipe/pipe.module';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { 
  MatAutocompleteModule,
  MatButtonModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatSelectModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatCardModule } from '@angular/material';
import { TduDetailsPageComponent } from './tdu-details-page/tdu-details-page.component';
@NgModule({
schemas: [
    CUSTOM_ELEMENTS_SCHEMA
],
  imports: [
    CommonModule,
    ServiceAvailabilityRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    PipeModule.forRoot(),
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatCardModule 
  ],
  providers: [ServiceAvailabilityService],
  declarations: [
  	TDUDetailsComponent,
  	TduDetailsPageComponent
  ]
})
export class ServiceAvailabilityModule { }



// WEBPACK FOOTER //
// ./src/app/service-availability/service-availability.module.ts